<template>
  <div id="components-back-top-demo-custom">
    <router-view></router-view>
    <!-- <a-back-top /> -->
    <a-back-top>
      <div class="ant-back-top-inner">
        <img class="inner-img" :src="backTop" alt="">
      </div>
    </a-back-top>
  </div>
</template>

<script>
 
export default {
  name: "App",
  components: {},
  data: function () {
    return {
      globalEnv: process.env,
      backTop: process.env.VUE_APP_CDN + '/app/back_to_top.png'
    }
  },
  watch: {
    '$route'(to, from) {
      console.log(`router ${from.path} from ${to.path}`);
      if (!to.path.includes('/product')) {
        console.log(`set normal backtop`)
        this.backTop = `${this.globalEnv.VUE_APP_CDN}/app/back_to_top.png`
      } else {
        console.log(`set white backtop`)
        this.backTop = `${this.globalEnv.VUE_APP_CDN}/app/back_to_top_white.png`
      }
    }
  },
  mounted() {
    // 关闭loading
    document.getElementById('mainLoading').style.display = 'none';
    console.log("in App.vue lang:", this.$t("language.zh"))

    // 默认浅色
    window.localStorage.setItem('theme', 'light');
    document.documentElement.setAttribute('theme', 'light');
    console.log("App.vue load finish")

    if (!window.localStorage.getItem('lang')) {
      console.log('set to default zh');
      window.localStorage.setItem('lang', 'zh')
      this.$i18n.locale = 'zh'
    }
  },
  methods: {}
};
</script>

<style>

@font-face {
  font-family: MiSans;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSans-Bold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}


@font-face {
  font-family: MiSans-Demibold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}


@font-face {
  font-family: MiSans-Medium;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSans-Normal;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSans-Regular;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSans-Semibold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSans-Thin;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSansVF;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSansVF_Bold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSansVF_Demibold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSansVF_Medium;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

@font-face {
  font-family: MiSansVF_Semibold;
  src: url("https://cdn.rivai-ic.com.cn/production/homepage/app/MiSans_VF.ttf");
}

.ant-carousel .slick-dots li.slick-active button {
  background: #aeaeae !important;
  height: 10px !important;
  border-radius: 5px !important;
}

.ant-carousel .slick-dots li button {
  background: #aeaeae !important;
  height: 10px !important;
  border-radius: 5px !important;
}

#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}

#components-back-top-demo-custom .ant-back-top-inner {
  height: 40px;
  width: 40px;
}

#components-back-top-demo-custom .ant-back-top-inner .inner-img {
  width: 100%;
}

</style>
<style lang="less" src="./app.less">

</style>

<style lang="less" src="./app_m.less">

</style>
